module.exports = __webpack_public_path__ + "static/media/wrapper-title.927d0323.png";